import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSector, createSeats } from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { SectorForm } from '../SectorForm'
import { ROUTES } from '~/views/routes'
import history from '~/config/history'
import { PositionDescriptor, SEATS_STATUS, SeatStatus } from 'config/constants'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'

export const SectorCreatePage = ({ match, onSuccess }) => {
  const { pendingCreateLayout, pendingCreateSeats } = useSelector(
    (state) => state.planimetry
  )
  const { locationId, layoutId } = match.params

  const dispatch = useDispatch()

  const initializeSeats = (numRows, numColumns) => {
    const newSeats = Array.from({ length: numRows * numColumns }, (_, idx) => ({
      row: Math.floor(idx / numColumns) + 1,
      column: (idx % numColumns) + 1,
      status: SeatStatus.Available
    }))
    return newSeats
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      const sector = await dispatch(createSector(values))
      const payload = {
        SectorId: sector.Id,
        Column: values.Column,
        Row: values.Row,
        Seats: initializeSeats(values.Row, values.Column).map((seat) => ({
          Column: seat.column,
          Row: seat.row,
          IsSeat: true,
          Status: SEATS_STATUS[seat.status],
          Id: seat.id
        }))
      }
      await dispatch(createSeats(payload))
      onSuccess(locationId, layoutId)
      showSnackbarSuccess('Sector Creado!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    SectorName: '',
    Column: '',
    ColumnDescriptor: PositionDescriptor.Numeric,
    Row: '',
    RowDescriptor: PositionDescriptor.Numeric,
    ImageId: '',
    ImageFile: null,
    LayoutId: layoutId,
    Color: ''
  }

  return (
    <PaperContainer title='Creación de Sector'>
      <SectorForm
        values={values}
        actionText='Crear'
        handleSubmit={handleSubmit}
        actionPending={pendingCreateLayout || pendingCreateSeats}
        onCancel={() =>
          history.push(
            ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.INDEX.replace(
              ':locationId',
              locationId
            ).replace(':layoutId', layoutId)
          )
        }
      />
    </PaperContainer>
  )
}

export default SectorCreatePage
